import {EntityApiService, ApiClientService} from '@dofleini/security';
import AuditsApiService from '@/modules/analytics/services/AuditsApiService';
import {
  removeServiceFilter
} from '@/modules/clientRegisters/services/ClientRegistersApiService';

const transformData =(data) => {
  return data?.map(item => ({
    title: item?.establishment?.name,
    key: item?.establishment?._id,
    percentage: item?.percentage,
    isEstablishment: true,
    children: item?.areas?.map(area => ({
      title: area?.area?.name,
      key: area?.area?._id,
      percentage: area?.percentage
    }))
  }));
};

class ReportsApiService extends EntityApiService {
  downloadPDFAudit = async (params) => {
    ApiClientService.pushDefaultHeader('Accept', 'application/pdf');
    ApiClientService.pushDefaultHeader('Content-Disposition', 'attachment');
    let query = '?isPreview=false';
    if (params.isPreview) {
      query = '?isPreview=true';
    }
    const response = await ApiClientService.get(this.getPath(`/audit/${params._id}/public${query}`));
    const { data } = response;
    if (data?.pdfSendToGenerate) {
      return data;
    } else if (data?.pdfUrl) {
      const link = document.createElement('a');
      link.href = data?.pdfUrl;
      link.download = params.pdfName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return data;
    }

    return data;
  };
  downloadIncidentsExcel = async (params) => {
    const response = await ApiClientService.post(this.getPath('/issues/export-excel'), params);
    return response?.data;
  }

  registerStatistics = async (params) => {
    const newParams = {...AuditsApiService.getSummaryParams(params)};
    newParams.date = newParams.dayDate;
    delete newParams.dayDate;
    const result = await ApiClientService.post('/ms-statistics/api/register-statistics/by-establishment-completion', { 
      ...newParams, 
      ...removeServiceFilter(params),
    });
    result.data = transformData(result.data);
    return result;
  }

}

export default new ReportsApiService('/ms-core/api/reports');
